import { render, staticRenderFns } from "./ProcessesTeam.vue?vue&type=template&id=55331770&"
import script from "./ProcessesTeam.vue?vue&type=script&lang=js&"
export * from "./ProcessesTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports